import React from 'react';

import step1 from 'assets/img/step1.svg';
import step2 from 'assets/img/step2.svg';
import step3 from 'assets/img/step3.svg';

const data = [
  { text: 'Escolha o evento que não quer perder por nada.', img: step1 },
  { text: 'Responda à pergunta mas não se engane.', img: step2 },
  { text: 'Não se esqueça de preencher o seu email e enviar.', img: step3 },
];

const Step = ({ text, img }) => {
  return (
    <li className="steps__item">
      <figure className="steps__img">
        <img src={img} alt="" />
      </figure>
      <span className="steps__title">Passo</span>
      <p className="steps__text">{text}</p>
    </li>
  );
};

const Steps = () => {
  const steps = data.map((step, i) => <Step key={i} {...step} />);
  return <ul className="steps">{steps}</ul>;
};

export default Steps;
